type IconProps = {
  className?: string;
  size?: number;
};

export function IconTriangle({ className = "", size = 24 }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      className={className}
    >
      <path
        fill="currentColor"
        d="m22.675 16.254-9.474-8.8c-.651-.605-1.75-.605-2.402 0l-9.475 8.8C.613 16.915 1.15 18 2.187 18h19.625c1.04 0 1.575-1.085.863-1.746Z"
      />
    </svg>
  );
}
